import styled from 'styled-components';
import C from '@assets/themes/colors';
import D from '@assets/themes/dimensions';

interface IStyleProps {
  height?: number;
  showError? : boolean;
};

export const Root = styled.div`
  display: block;
  top: 0px;
  left: 0px;
  width: 100%;
  height: fit-content;
`

export const BarContainer = styled.div`
  width: 100%;
  height: ${D.APP_BAR_HEIGHT}px;
  background-image: linear-gradient(45deg, ${C.LIGHT_ORANGE}, ${C.ORANGE});
  display: flex;
  align-items: center;
  transition: height 0.4s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
`
export const BackContainer = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
  width: 300px;
  min-width: 300px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  cursor: pointer;
`

export const TitleContainer = styled.div`
  padding-left: 22px;
  font-size: 25px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
  cursor: pointer;
`
export const InputContainer = styled.div`
  display: block;
  flex-grow: 4; 
`;

export const TitleInput = styled.input`
  font-family: Roboto;
  font-size: 25px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.WHITE};
  padding: 0px;
  border: none;
  width: 70%;
  background-color: transparent;
  outline: none;
`

export const ErrorMessage = styled.div`
  position: absolute;
  margin-top: 2px;
  text-align: center;
  justify-content: center;
  max-height: 0px;
  display: block;
  opacity: ${(props: IStyleProps) => (props.showError ? 1 : 0)};
  transition: opacity 0.2s, max-height 0s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-delay: ${(props: IStyleProps) => (props.showError ? '0.5s' : 'unset')};
  overflow: hidden;
  z-index: 60;
  max-height: 500px;
  
`

export const TextTitle = styled.div`
  color: ${C.DARKER_WHITE};
  display: flex;
  align-items: center;
  padding: 0px 14px;;
  height: 31px;
  background-color: ${C.DARKEST_GRAY};
  text-align: center;
  border-radius: 4px;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 500;
`

export const MetaDataOptionIconContainer = styled.div`
  cursor: pointer;
`;
